import { VariantService } from 'src/app/angularJS/services/variant/variant.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller used to create new variants on a product
 */
export class VariantCreateController {
  private static $inject = [
    '$state',
    '$stateParams',
    '$rootScope',
    'variantService',
    'UserMessages',
    'ACTToolbarService',
    'catalogueConstants',
    'breadcrumbService'
  ];

  public currentSchemaId: string;
  public required: InterACT.Interfaces.Catalogues.Variant;
  public channelAvailableValues: Array<string>;
  public existingModel: InterACT.Interfaces.Catalogues.Product;
  private catalogue: InterACT.Interfaces.Catalogues.Catalogue;
  private product: InterACT.Interfaces.Catalogues.Product;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams,
    private $rootScope,
    private variantService: VariantService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    private catalogueConstants: InterACT.Interfaces.ICatalogueConstants,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  /**
   * Creates a variant by merging the data entered in the form with the required data
   * @param data the variant data entered in the form
   * @returns a promise from the variant service
   */
  public createVariant = (data: InterACT.Interfaces.Catalogues.Variant) => {
    _.merge(data, this.required);
    data.fields = this.getDifference(data.fields, this.product.fields);
    this.$rootScope.showSpinner = true;
    this.variantService.create(this.catalogue.id, this.product.id, data).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('TOAST_MESSAGE.VARIANT.CREATED');
      this.exitCreateVariant();
    });
  }

  /**
   * Exits the create product view to the product list view
   * @returns a promise from the state provider
   */
  public exitCreateVariant = () => {
    this.$state.go('variants.list', {
      catalogueId: this.catalogue.id,
      catalogueVersion: this.catalogue.version,
      productId: this.product.id
    });
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.product = this.$stateParams.product;
    this.existingModel = angular.copy(this.product);
    this.catalogue = this.$stateParams.catalogue;
    this.currentSchemaId = this.product.type;
    this.required = <any>{};
    this.required.channels = [];
    this.required.tags = [];
    this.channelAvailableValues = this.catalogueConstants.CHANNELS;
    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'CATALOGUES',
        sref: 'catalogues.list'
      }, {
        name: this.catalogue.scheme.abbreviation,
        sref: 'catalogue.product-list',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version
        }
      }, {
        name: this.product.name,
        sref: 'variants.list',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version,
          productId: this.product.id
        }
      }
    ]);

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('HEADING.CREATE_VARIANT');
    });
  }

  /**
   * Retrieves any differing attributes between two objects
   * Found: https://gist.github.com/Yimiprod/7ee176597fef230d1451
   * Lack of support currently in lodash
   * @param updatedObject the object where the changes where enacted
   * @param originalObject the base object serving as the starting point
   * @returns an object containing only the altered fields
   */
  private getDifference(updatedObject, originalObject) {
    return _.transform(updatedObject, (result, value, key) => {
      if (!_.isEqual(value, originalObject[key])) {
        result[key] = (_.isObject(value) && _.isObject(originalObject[key]))
          ? this.getDifference(value, originalObject[key])
          : value;
      }
    });
  }
}